import axios from 'axios'
import qs from 'qs';
import router from '../router'


axios.defaults.timeout = 1000*60;
if (process.env.NODE_ENV == 'development') {
  // axios.defaults.baseURL = 'http://www.iyo.pub:8084/cshf-platform'
 axios.defaults.baseURL="https://www.sccshf.com:8084/cshf-platform"
   // axios.defaults.baseURL="http://localhost:8084/cshf-platform"
} else if (process.env.NODE_ENV == 'production') {
  // axios.defaults.baseURL = 'http://47.104.76.177';
  // axios.defaults.baseURL = 'http://www.iyo.pub:8084/cshf-platform';
  axios.defaults.baseURL="https://www.sccshf.com:8084/cshf-platform"
}else if(process.env.NODE_ENV == 'testing') {
  // axios.defaults.baseURL = 'http://47.110.65.40:22';
  axios.defaults.baseURL="https://www.sccshf.com:8084/cshf-platform"
}

axios.interceptors.request.use(
    config => {
        config.headers = {
            // 'Content-Type':'application/json;charset=utf-8',
            "Accept": "*/*",
            "Access-Control-Allow-Origin": '*',
            'Access-Control-Allow-Headers': "Authorization,Origin, X-Requested-With, Content-Type, Accept",
            "content-type": "application/json;charset=UTF-8",
            'token':'38cb4997482b0ab8b531a2c0654184e8'
        }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);

//http response 拦截器 拦截状态码处理错误
axios.interceptors.response.use(
  response => {
    if (String(response.data.code) == 5006) {
      // common.delCookie('user');
      // router.replace({
      //     path: 'login',
      //     // query: {redirect: router.currentRoute.fullPath}
      // })
    }
    if (response.data) {
      if (response.data.code) {

        if (response.data.code == "401") {
          router.replace({
            path: '/',
          })
        }

      }
    }

    return response;
  },
  error => {
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    if (!params.params) {
      params = {
        params: params
      }
    }
    axios.get(url, params)
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err)
      })
  })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
      .then(response => {
        resolve(response.data);
      }).catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装登陆请求
 * @param url
 * @param data
 * @returns {Promise}
 */

// export function login(url, data = {}) {
//   return new Promise((resolve, reject) => {
//     axios.post(url, qs.stringify(data))
//       .then(response => {
//         resolve(response.data);
//       }).catch(err => {
//       reject(err)
//     })
//   })
// }



// WEBPACK FOOTER //
// ./src/http/http.js